export const isLightPageV2 = (pathname: string) => {
  return pathname === '/' || pathname === '/start';
};

const PHONE_FLOW_PATH_PREFIXES = [
  '/shop/products/light-phone-ii',
  '/shop/products/light-phone-iii',
  '/shop/products/light-flip'
];

export const isPhoneFlowPage = (pathname: string) =>
  PHONE_FLOW_PATH_PREFIXES.some((prefix) => pathname.startsWith(prefix));
